var map = {
	"./Icon_marketplace.svg": "e391",
	"./ahorro_kuspit.svg": "5477",
	"./alert.svg": "659f",
	"./alert_error.svg": "5ea8",
	"./allianz.svg": "40c4",
	"./attachment.svg": "3e0e",
	"./back.svg": "7338",
	"./back_blue.svg": "68f6",
	"./bulb.svg": "e9f9",
	"./calendar.svg": "b8bd",
	"./calendar_blue.svg": "5acd",
	"./calendar_goals.svg": "cf4e",
	"./card.svg": "5d4a",
	"./check_with_green_placeholder_background.svg": "8847",
	"./contract-savings.svg": "4d05",
	"./credential.svg": "56c4",
	"./cubo.svg": "2ffe",
	"./custom-goal-icons/dashboard/icon-car-w.svg": "5af2",
	"./custom-goal-icons/dashboard/icon-car.svg": "fb03",
	"./custom-goal-icons/dashboard/icon-certificate-w.svg": "72e3",
	"./custom-goal-icons/dashboard/icon-certificate.svg": "fa68",
	"./custom-goal-icons/dashboard/icon-fund.svg": "31a0",
	"./custom-goal-icons/dashboard/icon-house.svg": "f317",
	"./custom-goal-icons/dashboard/icon-person-w.svg": "8e01",
	"./custom-goal-icons/dashboard/icon-person.svg": "9f8c",
	"./custom-goal-icons/dashboard/icon-plane.svg": "68a5",
	"./custom-goal-icons/dashboard/icon-retirement.svg": "3934",
	"./custom-goal-icons/icon-add.svg": "1fe4",
	"./custom-goal-icons/icon-car-white.svg": "cc77",
	"./custom-goal-icons/icon-car.svg": "0c2b",
	"./custom-goal-icons/icon-certificate-white.svg": "f742",
	"./custom-goal-icons/icon-certificate.svg": "bd9b",
	"./custom-goal-icons/icon-coins.svg": "dc0e",
	"./custom-goal-icons/icon-edit-white.svg": "a841",
	"./custom-goal-icons/icon-edit.svg": "3a75",
	"./custom-goal-icons/icon-fund-active.svg": "8732",
	"./custom-goal-icons/icon-fund-sky-blue.svg": "2ac4",
	"./custom-goal-icons/icon-fund-white.svg": "a197",
	"./custom-goal-icons/icon-fund.svg": "cc25",
	"./custom-goal-icons/icon-house-active.svg": "e293",
	"./custom-goal-icons/icon-house-white.svg": "844a",
	"./custom-goal-icons/icon-house.svg": "6e01",
	"./custom-goal-icons/icon-person-white.svg": "7652",
	"./custom-goal-icons/icon-person.svg": "26c1",
	"./custom-goal-icons/icon-plane-white.svg": "976a",
	"./custom-goal-icons/icon-plane.svg": "650d",
	"./custom-goal-icons/icon-retirement-active.svg": "51ab",
	"./custom-goal-icons/icon-retirement-sky-blue.svg": "e94a",
	"./custom-goal-icons/icon-retirement-white.svg": "a849",
	"./custom-goal-icons/icon-retirement.svg": "b7b5",
	"./custom-goal-icons/noun-coins.svg": "fcda",
	"./dashboard-wealth/flag_goals.svg": "4a89",
	"./dashboard-wealth/link_goals.svg": "a0e5",
	"./dashboard-wealth/profiling.svg": "0e1c",
	"./document_color.svg": "58aa",
	"./documents.svg": "70cd",
	"./email.svg": "43be",
	"./fill_1.svg": "bfdc",
	"./fill_2.svg": "bc21",
	"./fill_3.svg": "ffa0",
	"./flexible.svg": "3fec",
	"./flexible_white.svg": "c507",
	"./goals-dashboard/inflation-lock-white.svg": "76ce",
	"./goals-dashboard/inflation-lock.svg": "1bfe",
	"./goals-icons/icon-add.svg": "8993",
	"./goals-icons/icon-graphics.svg": "6443",
	"./goals-icons/icon-house.svg": "acf8",
	"./goals-icons/icon-piggy-bank.svg": "a5c4",
	"./goals-icons/icon-plane.svg": "3d10",
	"./goals-icons/icon-user.svg": "5c7b",
	"./goals.svg": "39b9",
	"./icon-bank.svg": "d366",
	"./icon-car.svg": "82af",
	"./icon-user.svg": "e7c2",
	"./icon_Clock.svg": "cf48",
	"./icon_ahorro.svg": "e274",
	"./icon_ahorro_black.svg": "5d1a",
	"./icon_clock_with_background.svg": "29fc",
	"./icon_credit.svg": "91ef",
	"./icon_flagship.svg": "8382",
	"./icon_gasto.svg": "9240",
	"./icon_goals.svg": "a5e8",
	"./icon_house.svg": "eead",
	"./icon_pocket.svg": "c76a",
	"./icon_protect.svg": "deeb",
	"./icon_tickcircle.svg": "ff37",
	"./icon_travel.svg": "fb2c",
	"./icon_user_with_background.png": "5be7",
	"./icon_wealth.svg": "6853",
	"./important.svg": "0c39",
	"./inversion_allianz.svg": "7b4c",
	"./join_pocket.svg": "7dfd",
	"./join_wealth.svg": "82bc",
	"./kuspit-logo.svg": "9b04",
	"./kuspit.svg": "6fb2",
	"./loading.svg": "1e31",
	"./location.svg": "d2eb",
	"./logo_sowos.svg": "b60c",
	"./logo_sowos_pocket.svg": "8e2f",
	"./logo_sowos_pocket_white.svg": "b54f",
	"./logo_sowos_wealth.svg": "5da7",
	"./logo_sowos_wealth_white.svg": "f0bd",
	"./loupe.svg": "f39b",
	"./marketplace_card.svg": "93dc",
	"./menu_item.svg": "6807",
	"./menu_item1.svg": "464d",
	"./menu_item2.svg": "7adb",
	"./menu_item3.svg": "3a0e",
	"./menu_item4.svg": "c3b7",
	"./menu_item_document.svg": "133c",
	"./minus.svg": "3e24",
	"./nav-bar/back.svg": "77a8",
	"./nav-bar/notifications_off.svg": "6736",
	"./nav-bar/notifications_on.svg": "3198",
	"./not-found.svg": "aefc",
	"./notifications.svg": "f587",
	"./noun-child.svg": "9f68",
	"./noun-pet.svg": "89b1",
	"./phone.svg": "c3bb",
	"./pocket_activation.svg": "5bdb",
	"./process.svg": "d3ae",
	"./recurring.svg": "a57f",
	"./recurring_white.svg": "640f",
	"./revission.svg": "a9d4",
	"./strategy-moderate-wealth/icon-documents.svg": "75b0",
	"./strategy-moderate-wealth/icon-gear.svg": "13ee",
	"./strategy-moderate-wealth/icon-moderate.svg": "fa70",
	"./transfer.svg": "f62e",
	"./update_documents.svg": "fc9e",
	"./wealth_activation.svg": "cc7e",
	"./welcome.svg": "85a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";